import {Empty, Loader, ProfileCircleIcon} from 'common/components'
import {useGetOrganisations} from '..'
import { List } from './List'

export default function OutletTeam() {
  const {data: resBody} = useGetOrganisations({
    type: 'team',
    searchKeyWords: '',
    pageNumber: 1,
  })
  const totalCount = resBody?.meta?.total || resBody?.data?.length || 0
  return (
    <>
      {!resBody?.data ? (
        <Loader />
      ) : resBody.data.length === 0 ? (
        <Empty
          icon={<ProfileCircleIcon width={40} height={40} />}
          title="organisation"
        />
      ) : (
        <List
          items={resBody.data}
          total={totalCount}
          page={1}
          // setPage={setPage}
        />
      )}
    </>
  )
}
